import React from 'react';
import { Datagrid, DateField, Filter, FunctionField, List, NullableBooleanInput, SearchInput, useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { PartiallyHiddenCpfField } from '../../components/Fields';
import ListPagination from '../../components/ListPagination';
import { formatCellphone } from '../../utils';

// GET /chains/{chainId}/tag/{id}/customers (pontuax-backend src/api/tag/tag-customers.ts).
// signedUp = criou senha no app; sem senha é pré-cadastro (Importar CPFs ou cadastro não terminado).
const TagCustomersFilter: React.FC<any> = props => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <NullableBooleanInput
      source="signedUp"
      label="Cadastro no app"
      nullLabel="Todos"
      trueLabel="Cadastrado"
      falseLabel="Pré-cadastro"
      alwaysOn
      sx={{ minWidth: 200 }}
    />
  </Filter>
);

const TagCustomersTab: React.FC<{ label?: false }> = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <List
      resource={`chains/chainId/tag/${record.id}/customers`}
      title={false}
      perPage={25}
      pagination={<ListPagination />}
      sort={{ field: 'name', order: 'ASC' }}
      filters={<TagCustomersFilter />}
      actions={false}
      empty={false}
      disableSyncWithLocation
    >
      <Datagrid bulkActionButtons={false} rowClick={id => `/customers/${id}/show`}>
        <FunctionField source="name" label="Nome" render={customer => customer.name || 'Sem nome'} />
        <PartiallyHiddenCpfField source="cpf" label="CPF" />
        <FunctionField label="Celular" sortable={false} render={customer => formatCellphone(customer.cellphone) || '—'} />
        <FunctionField
          source="signedUp"
          label="Cadastro no app"
          render={customer => (
            <Chip
              size="small"
              label={customer.signedUp ? 'Cadastrado' : 'Pré-cadastro'}
              color={customer.signedUp ? 'success' : 'warning'}
              variant={customer.signedUp ? 'outlined' : 'filled'}
            />
          )}
        />
        <DateField source="createdAt" label="Cliente desde" locales="pt-BR" />
      </Datagrid>
    </List>
  );
};

export default TagCustomersTab;
